import axios from "axios";
import toast from "react-hot-toast";

import { BASE_URL } from "./constants";

export const ApiRequest = async ({ method, url, data }) => {
  try {
    let response = await axios({
      method: method,
      url: `${BASE_URL}/${url}`,
      data: data,
      headers: {
        Accept: "application/json",
      },
    });

    return response.data;
  } catch (error) {
    toast.error(error.response.data.message);
  }
};
